import { render, staticRenderFns } from "./titled.vue?vue&type=template&id=276f1ae6&scoped=true&"
import script from "./titled.vue?vue&type=script&lang=js&"
export * from "./titled.vue?vue&type=script&lang=js&"
import style0 from "./titled.vue?vue&type=style&index=0&lang=css&"
import style1 from "./titled.vue?vue&type=style&index=1&id=276f1ae6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f1ae6",
  null
  
)

export default component.exports